import React, { useEffect, useState } from "react";
import { Panel, Field } from "@/pages/admin/shared";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Save } from "lucide-react";
import { toast } from "sonner";
import api from "@/pages/admin/api";

export default function AboutEditor() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/site-content").then((r) => setData(r.data.about || {})); }, []);
  if (!data) return <div className="text-sm text-muted-foreground">Loading…</div>;

  const set = (k, v) => setData({ ...data, [k]: v });

  const save = async () => {
    setSaving(true);
    try { await api.put("/site-content", { about: data }); toast.success("About page updated"); }
    catch { toast.error("Save failed"); }
    finally { setSaving(false); }
  };

  return (
    <div className="space-y-6">
      <Panel title="About Content" actions={<Button data-testid="save-about" onClick={save} disabled={saving} className="rounded-xl bg-blue-600 hover:bg-blue-700 text-white"><Save size={14} className="mr-1" /> {saving ? "Saving..." : "Save"}</Button>}>
        <div className="grid md:grid-cols-2 gap-4">
          <Field label="Heading" className="md:col-span-2"><Input data-testid="about-heading" value={data.heading || ""} onChange={(e) => set("heading", e.target.value)} /></Field>
          <Field label="Description" className="md:col-span-2"><Textarea data-testid="about-desc" rows={4} value={data.description || ""} onChange={(e) => set("description", e.target.value)} /></Field>
          <Field label="Mission"><Textarea rows={3} value={data.mission || ""} onChange={(e) => set("mission", e.target.value)} /></Field>
          <Field label="Vision"><Textarea rows={3} value={data.vision || ""} onChange={(e) => set("vision", e.target.value)} /></Field>
          <Field label="Image URLs (comma separated)" className="md:col-span-2">
            <Input value={(data.images || []).join(", ")} onChange={(e) => set("images", e.target.value.split(",").map((s) => s.trim()).filter(Boolean))} />
          </Field>
        </div>
      </Panel>
    </div>
  );
}
